var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVips(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.133,
    height: 35.592,
    viewBox: "0 0 48.133 35.592",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "VIPS",
    transform: "translate(0.004 -0.003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27222",
    "data-name": "Trazado 27222",
    d: "M47.714,11.51c2.445,9.194-6.161,19.457-19.226,22.931S2.855,33.276.41,24.088,6.576,4.626,19.641,1.156,45.273,2.321,47.719,11.515",
    transform: "translate(0 0)",
    fill: "#d72a34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27223",
    "data-name": "Trazado 27223",
    d: "M21.078,32.068l2.034-4.378h3.4l-4.469,8.546H20.109L15.63,27.69h3.4Z",
    transform: "translate(-7.784 -13.785)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27224",
    "data-name": "Trazado 27224",
    d: "M40.206,28.227a2.466,2.466,0,0,1-1.516-.537v8.546h3.033V27.69a2.466,2.466,0,0,1-1.516.537",
    transform: "translate(-19.265 -13.785)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27225",
    "data-name": "Trazado 27225",
    d: "M41.717,20.918a1.978,1.978,0,1,1-1.978-1.978,1.989,1.989,0,0,1,1.978,1.978",
    transform: "translate(-18.802 -9.429)",
    fill: "#fadb3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27226",
    "data-name": "Trazado 27226",
    d: "M71.236,30.519c-.417-.085-1.366-.166-1.366-.748,0-.437.6-.582.949-.582a3.746,3.746,0,0,1,1.632.417l1.019-1.933a6.766,6.766,0,0,0-2.817-.552c-1.868,0-3.766.934-3.766,3.033a2.141,2.141,0,0,0,1.9,2.249c.949.251,1.9.281,1.9.949,0,.467-.567.648-.949.648a5.315,5.315,0,0,1-2.6-1.014,5.58,5.58,0,0,1-1,2.194,6.644,6.644,0,0,0,3.56,1.054c1.983,0,4.032-.934,4.032-3.183,0-1.582-1.064-2.249-2.485-2.531",
    transform: "translate(-32.927 -13.501)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27227",
    "data-name": "Trazado 27227",
    d: "M52.3,27.12a3.033,3.033,0,0,0-2.581,1.25h-.035v-.964H46.65V40.22h3.033V35.139a3.5,3.5,0,0,0,2.651,1.1A4.33,4.33,0,0,0,56.617,31.7,4.384,4.384,0,0,0,52.3,27.125m-.728,6.633a1.978,1.978,0,1,1,1.978-1.978,1.989,1.989,0,0,1-1.978,1.978",
    transform: "translate(-23.228 -13.501)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27228",
    "data-name": "Trazado 27228",
    d: "M84.984,21.134a1.017,1.017,0,1,1-1.014-1.054.96.96,0,0,1,1.014,1.054m-.186,0a.83.83,0,1,0-1.657,0,.83.83,0,1,0,1.657,0m-1.25-.557a.045.045,0,0,1,.05-.05h.427c.316,0,.5.146.5.4a.326.326,0,0,1-.306.362l.291.377s0,.05-.03.05h-.161a.1.1,0,0,1-.055-.03l-.281-.372h-.216v.362c0,.03-.015.04-.04.04H83.6c-.03,0-.05-.01-.05-.04Zm.422.552c.251,0,.336-.045.336-.206,0-.146-.09-.206-.311-.206h-.221v.407h.2Z",
    transform: "translate(-41.302 -9.996)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVips);
export default __webpack_public_path__ + "static/media/vips.5fcc2ffbfea990cc9881938e8f676cb0.svg";
export { ForwardRef as ReactComponent };